import React from 'react';
import { useNavigate } from '@tanstack/react-router';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { trpcClient } from '@/lib/trpc';
import { DesignForm, type DesignFormData } from './DesignForm';

export default function DesignCreate() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const createMutation = useMutation({
    mutationFn: async (data: DesignFormData) => {
      return (trpcClient as any).designs.create.mutate({
        productId: data.productId,
        designType: data.designType,
        quantity: data.quantity,
        description: data.description,
        assignedTo: data.assignedTo || undefined,
        filePaths: data.filePaths ? [data.filePaths] : undefined,
      });
    },
    onSuccess: (res: any) => {
      toast.success('Đã tạo phiếu yêu cầu thiết kế thành công');
      queryClient.invalidateQueries({ queryKey: ['designs'] });
      navigate({ to: '/designs' as any });
    },
    onError: (err: any) => {
      toast.error(err.message || 'Không thể tạo yêu cầu thiết kế');
    },
  });

  return (
    <DesignForm
      mode="create"
      isSubmitting={createMutation.isPending}
      onSubmit={async (data) => {
        await createMutation.mutateAsync(data);
      }}
      onCancel={() => navigate({ to: '/designs' as any })}
    />
  );
}
